import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form";
import { IUiSchema } from "@rentiohq/shared-frontend/dist/forms/forms.types";
import { getValue } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EBrokerFeature } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { JSONSchema6 } from "json-schema";
import { EField, IExtraData } from "./schema.tenantProfileBroker.types";

const INTAKE_TYPE_OPTIONS = [{ id: 1 }, { id: 2 }, { id: 3 }];

export const getSchema =
  (initialValues: { [key: string]: any }, extraData: IExtraData) =>
  (defaultValues: { [key: string]: any }): JSONSchema6 => {
    const hasRentMatch = extraData.broker.features?.includes(
      EBrokerFeature.RentMatch,
    );
    return {
      required: [EField.IntakeMail, EField.IntakeType],
      properties: {
        [EField.IntakeType]: {
          default: getValue(EField.IntakeType, initialValues, defaultValues),
          //@ts-ignore
          options: INTAKE_TYPE_OPTIONS.map(type => ({
            id: type.id,
            value: getLocalizedText(
              type.id === 3 && hasRentMatch
                ? `broker.rentmatch.intakeType.${type.id}`
                : `broker.intakeType.${type.id}`,
            ),
          })),
        },
        [EField.IntakeMail]: {
          default: getValue(EField.IntakeMail, initialValues, defaultValues),
        },
      },
    };
  };

export const uiSchema = (_extraData: IExtraData): IUiSchema<EField> => ({
  [EField.IntakeType]: {
    "ui:field": ERentioFormField.DropdownSelect,
    title: getLocalizedText("broker.tenant_profile.intake_type.label"),
  },
  [EField.IntakeMail]: {
    "ui:field": ERentioFormField.Email,
    title: getLocalizedText("broker.tenant_profile.intake_email.label"),
  },
});
